import React from 'react';
import './styles/JobSearchLoader.css';

interface JobSearchLoaderProps {
  progressPercent: number;
  progressMessage: string;
  titleText?: string;
}

const JobSearchLoader: React.FC<JobSearchLoaderProps> = ({ progressPercent, progressMessage, titleText = "Processing Search" }) => {
  const steps = [
    { id: 1, title: 'Initializing', subtitle: 'Setting up search', threshold: 10 },
    { id: 2, title: 'Retrieving', subtitle: 'Fetching profiles', threshold: 40 },
    { id: 3, title: 'Analyzing', subtitle: 'JozAI Processing', threshold: 80 },
    { id: 4, title: 'Finalizing', subtitle: 'Matching candidates', threshold: 100 }
  ];

  const currentStepIndex = steps.findIndex(step => progressPercent <= step.threshold) !== -1
    ? steps.findIndex(step => progressPercent <= step.threshold)
    : steps.length - 1;

  return (
    <div className="job-search-loader-container">
      <div className="loader-header">
        <div className="loader-title">
          {titleText}<span>.</span><span>.</span><span>.</span>
        </div>
        <div className="loader-counter">
          <div className="num">{progressPercent}%</div>
          <div className="lbl">Complete</div>
        </div>
      </div>

      <div className="loader-track">
        {steps.map((step, index) => {
          const isActive = index === currentStepIndex;
          const isDone = index < currentStepIndex || progressPercent >= 100;

          let className = "checkpoint";
          if (isActive) className += " active";
          if (isDone) className += " done";
          if (isDone || isActive) className += " filled";

          return (
            <div key={step.id} className={className}>
              <div className="stamp">
              </div>
              <div className="cp-body">
                <div className="cp-title">{step.title}</div>
                <div className="cp-sub">{step.subtitle}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="loader-message-bar">
        <div className="status-message">
          <span>Current Status:</span> <b>{progressMessage || 'Initializing search with JozAI'}</b>
        </div>
      </div>
    </div>
  );
};

export default JobSearchLoader;
